<script setup>
import { Head } from '@inertiajs/vue3';
import LegalPageLayout from '@/Layouts/LegalPageLayout.vue';
import LegalSection from '@/Components/LegalSection.vue';
import LegalList from '@/Components/LegalList.vue';

defineProps({
    terms: String,
});
</script>

<template>
    <br /><br />
    asdfasdf

    <Head title="Terms of Service" />

    <LegalPageLayout title="Terms of Service for Spicy Collab">
        <p>
            <span class="font-bold">Effective Date:</span>
            September 1, 2024
        </p>
        <p>
            Welcome to Spicy Collab, accessible at
            <a href="http://www.spicycollab.com" class="text-orange-600 hover:text-orange-800">
                www.spicycollab.com
            </a>
            . By accessing or using our website, you agree to comply with and be bound by these Terms and
            Conditions.
        </p>

        <LegalSection title="1. Acceptance of Terms">
            <p>
                By using Spicy Collab, you agree to be bound by these Terms and Conditions and our Privacy
                Policy. If you do not agree, stop using the website immediately.:
            </p>
        </LegalSection>

        <LegalSection title="2. Use of the Website">
            <LegalList :items="[
                'You must be at least 18 years old to use this website.',
                'You are responsible for providing accurate and up-to-date information.',
                'You agree to use the website for lawful purposes only.',
            ]"></LegalList>
        </LegalSection>

        <LegalSection title="3. User Accounts">
            <LegalList :items="[
                'To access certain features, you may need to create an account. You are responsible for all activities under your account.',
                'Notify us immediately of unauthorized account use.',
            ]"></LegalList>
        </LegalSection>

        <LegalSection title="4. Payments">
            <p>
                Payments are processed by Stripe. You agree to comply with Stripe’s terms. We are not
                responsible for issues arising from Stripe payments.
            </p>
        </LegalSection>

        <LegalSection title="5. Intellectual Property">
            <LegalList :items="[
                'All content on Spicy Collab is owned by Spicy Collab or its licensors.',
                'You may not reproduce, distribute, or create derivative works from any content without permission.',
            ]"></LegalList>
        </LegalSection>

        <LegalSection title="6. Prohibited Conduct">
            <p>When using our website, you agree not to:</p>
            <LegalList :items="[
                'Engage in unlawful activities.',
                'Post harmful or defamatory content.',
                'Attempt unauthorized access to our servers or accounts.',
            ]"></LegalList>
        </LegalSection>

        <LegalSection title="7. Termination">
            <p>
                We reserve the right to terminate or suspend access at our discretion for any violation of
                these Terms.
            </p>
        </LegalSection>

        <LegalSection title="8. Limitation of Liability">
            <LegalList :items="[
                'Spicy Collab is provided on an “as-is” basis. We do not guarantee uninterrupted service.',
                'We are not liable for any damages from the use of the website.',
            ]"></LegalList>
        </LegalSection>

        <LegalSection title="9. Governing Law">
            <p>
                These Terms are governed by the laws of [Insert Jurisdiction]. You agree to submit to the
                exclusive jurisdiction of the courts of Nevada.
            </p>
        </LegalSection>

        <LegalSection title="10. Changes to Terms">
            <p>
                We may modify these Terms at any time. Changes will be posted with an updated “Effective
                Date.” Your continued use of the site constitutes acceptance of the new terms.
            </p>
        </LegalSection>

        <LegalSection title="11. Contact Information">
            <p>
                If you have any questions, contact us at
                <a href="mailto:admin@spicycollab.com" class="text-orange-600 hover:text-orange-800">
                    admin@spicycollab.com
                </a>
            </p>
        </LegalSection>
    </LegalPageLayout>
</template>
